/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';
import { ModalitaConvenzione } from './modalita-convenzione';


export interface PraticaEsercenteStatoPatchForm { 
    nuovo_stato: RichiestaPraticaEsercenteStatus;
    version: number;
    nota?: string;
    modalita_convenzione?: ModalitaConvenzione;
}



